<template>
  <div>
    <template v-if="colors.length">
      <v-chip small dark v-for="(item,index) in colors" :key="index" class="ml-1 mt-1" close :color="item" @click:close="onDeleteItem(index)"></v-chip>
    </template>
    <v-icon small class="ml-1" color="primary" @click="onAddItem">mdi-plus-circle</v-icon>
    <v-row justify="end" class="pr-4 mt-4" align="end">
      <a v-if="colors.length>1" class="caption primary--text mr-2" @click="onSort">排序</a>
      <a v-if="colors.length" class="caption primary--text mr-2" @click="onClear">清除</a>
      <v-btn v-if="colors.length" color="primary" small @click="$emit('change',colors.join(','))">确定</v-btn>
    </v-row>

    <v-dialog v-model="colorPickerVisible" max-width="300">
      <v-card>
        <v-card-title>颜色选择
          <a v-if="showSwatches" @click="showSwatches=false" class="caption ml-2 mt-1">隐藏色板</a>
          <a v-else @click="showSwatches=true" class="caption ml-2 mt-1">显示色板</a>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-color-picker mode="hexa" hide-inputs v-model="selectedColor" :show-swatches="showSwatches"></v-color-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="colorPickerVisible=false">取消</v-btn>
          <v-btn color="primary" @click="onAddItemOk">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="colorSortVisible" max-width="300">
      <v-card>
        <v-card-title>颜色排序</v-card-title>
        <v-card-text>
          <table>
            <tr v-for="(item,index) in colors" :key="index">
              <td width="26" :style="`background-color:${item}`">&nbsp;</td>
              <td width="80">{{item}}</td>
              <td width="80">
                <v-icon color="primary" small v-if="index!=0" @click="on_multiEdit_up(index)">mdi-chevron-up</v-icon>
                <v-icon color="primary" small v-if="index!=0" @click="on_multiEdit_double_up(index)">mdi-chevron-double-up</v-icon>
                <v-icon color="primary" small v-if="index!=colors.length-1" @click="on_multiEdit_down(index)">mdi-chevron-down</v-icon>
                <v-icon color="primary" small v-if="index!=colors.length-1" @click="on_multiEdit_double_down(index)">mdi-chevron-double-down</v-icon>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>
<script>
/* eslint-disable no-console */
export default {
  data () {
    return {
      colors: [],
      colorPickerVisible: false,
      selectedColor: '#FFFFFF',
      colorSortVisible: false,
      showSwatches: false
    }
  },
  methods: {
    onAddItem () {
      this.colorPickerVisible = true;
    },
    onAddItemOk () {
      this.colors.push(this.selectedColor);
      this.colorPickerVisible = false;
    },
    onDeleteItem (index) {
      this.colors.splice(index, 1);
    },
    onClear () {
      this.colors = [];
    },

    onSort () {
      this.colorSortVisible = true;
    },
    on_multiEdit_up (index) {
      let rows = this.colors;
      rows.splice(index - 1, 0, ...rows.splice(index, 1));
    },
    on_multiEdit_double_up (index) {
      let rows = this.colors;
      rows.splice(0, 0, ...rows.splice(index, 1));
    },
    on_multiEdit_down (index) {
      let rows = this.colors;
      rows.splice(index + 1, 0, ...rows.splice(index, 1));
    },
    on_multiEdit_double_down (index) {
      let rows = this.colors;
      rows.splice(rows.length - 1, 0, ...rows.splice(index, 1));
    }
  },
  created () {
  }
}
</script>